import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'

export default {
    path: '/souceManage',
    name: 'SouceManage',
    meta: {
        title: '教研管理',
        keepAlive: false
    },
    component: Layout,
    redirect: '/SouceManage/souceList',
    children: [{
        path: 'souceList',
        name: 'SouceList',
        meta: {
            title: '视频列表',
            keepAlive: false
        },
        component: resolve => require(['@/views/souceManage/souceList/Index.vue'], resolve)
    }, {
        path: 'souceList',
        name: 'souceList',
        meta: {
            title: '视频列表',
            keepAlive: false
        },
        component: Empty,
        children: [{
            path: 'souceAdd',
            name: 'SouceAdd',
            meta: {
                title: '编辑视频',
                keepAlive: false
            },
            component: resolve => require(['@/views/souceManage/souceList/souceAdd.vue'], resolve)

        }]
    }]
}
